// Module
var code = "<td class=\"timewriting-table-column__value decimal\"> <span data-bind=\"text: FormatValue(_cell.Value())\"></span> </td>";
// Exports
export default code;